( function( window, document, $ ) {
    'use strict';

    // --------------------------------------------------
    // VARIABLES
    // --------------------------------------------------
    var body = $( 'body' ),
        iconStyles,
        mapStyle;

    var googleMapIcons = {
        tbw: {
            eventMapIcon:
                'data:image/svg+xml;base64,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',
            neighbourhoodMapIcon:
                'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGZpbGw9IiNFRDY5MDAiIGN4PSI1IiBjeT0iNSIgcj0iNSIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+Cg==',
        },
        tcw: {
            eventMapIcon:
                'data:image/svg+xml;charset=utf-8;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDYwIDY2Ij48ZyBmaWxsPSJub25lIj48cGF0aCBkPSJNNjAgMzBDNjAgMTMuNCA0Ni42IDAgMzAgMFMwIDEzLjQgMCAzMGMwIDE0LjQgMTAuMSAyNi40IDIzLjYgMjkuM2w2LjQgNi40IDYuNC02LjRDNDkuOSA1Ni40IDYwIDQ0LjQgNjAgMzB6IiBmaWxsPSIjMDAwIi8+PHBhdGggZD0iTTMwIDU2LjVDMTUuNCA1Ni41IDMuNSA0NC42IDMuNSAzMFMxNS40IDMuNSAzMCAzLjUgNTYuNSAxNS40IDU2LjUgMzAgNDQuNiA1Ni41IDMwIDU2LjV6bTAtNTJDMTUuOSA0LjUgNC41IDE1LjkgNC41IDMwUzE1LjkgNTUuNSAzMCA1NS41IDU1LjUgNDQuMSA1NS41IDMwIDQ0LjEgNC41IDMwIDQuNXoiIGZpbGw9IiNGRkYiIG9wYWNpdHk9Ii42Ii8+PHBhdGggZD0iTTQ1IDE2LjhsLjMtLjktNy4xLTEuOS0xLjkgNi4xSDE5djI0LjZoMjEuMVYyMC4xaC0yLjhsMS41LTQuOSA2LjIgMS42em0tNS45IDI2LjhIMjB2LTQuNGgxOS4xdjQuNHptMC0yMi41djE3LjFIMjBWMjEuMWgxNmwtMS45IDYuMUgyMC42djEwLjRoMTcuOVYyNy4yaC0zLjNsMS45LTYuMWgyeiIgZmlsbD0iI0ZGRiIvPjwvZz48L3N2Zz4=',
            neighbourhoodMapIcon:
                'data:image/svg+xml;charset=utf-8;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGZpbGw9IiMwMDAwMDAiIGN4PSI1IiBjeT0iNSIgcj0iNSIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+',
        },
    };

    var googleMapThemes = {
        tbw: [
            {
                featureType: 'all',
                elementType: 'labels',
                stylers: [
                    {
                        visibility: 'on',
                    },
                ],
            },
            {
                featureType: 'all',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        saturation: 36,
                    },
                    {
                        color: '#000000',
                    },
                    {
                        lightness: 40,
                    },
                ],
            },
            {
                featureType: 'all',
                elementType: 'labels.text.stroke',
                stylers: [
                    {
                        visibility: 'on',
                    },
                    {
                        color: '#000000',
                    },
                    {
                        lightness: 16,
                    },
                ],
            },
            {
                featureType: 'all',
                elementType: 'labels.icon',
                stylers: [
                    {
                        visibility: 'off',
                    },
                ],
            },
            {
                featureType: 'administrative',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        color: '#000000',
                    },
                    {
                        lightness: 20,
                    },
                ],
            },
            {
                featureType: 'administrative',
                elementType: 'geometry.stroke',
                stylers: [
                    {
                        color: '#000000',
                    },
                    {
                        lightness: 17,
                    },
                    {
                        weight: 1.2,
                    },
                ],
            },
            {
                featureType: 'administrative.country',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        color: '#c4c4c4',
                    },
                ],
            },
            {
                featureType: 'administrative.locality',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        color: '#c4c4c4',
                    },
                ],
            },
            {
                featureType: 'administrative.neighborhood',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        color: '#c4c4c4',
                    },
                ],
            },
            {
                featureType: 'landscape',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#000000',
                    },
                    {
                        lightness: 20,
                    },
                ],
            },
            {
                featureType: 'poi',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#000000',
                    },
                    {
                        lightness: 21,
                    },
                    {
                        visibility: 'on',
                    },
                ],
            },
            {
                featureType: 'poi.business',
                elementType: 'geometry',
                stylers: [
                    {
                        visibility: 'on',
                    },
                ],
            },
            {
                featureType: 'road.highway',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        color: '#575757',
                    },
                    {
                        lightness: '0',
                    },
                ],
            },
            {
                featureType: 'road.highway',
                elementType: 'geometry.stroke',
                stylers: [
                    {
                        visibility: 'off',
                    },
                ],
            },
            {
                featureType: 'road.highway',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        color: '#ffffff',
                    },
                ],
            },

            {
                featureType: 'road.arterial',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#000000',
                    },
                    {
                        lightness: 18,
                    },
                ],
            },

            {
                featureType: 'road.arterial',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        color: '#575757',
                    },
                ],
            },

            {
                featureType: 'road.arterial',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        color: '#ffffff',
                    },
                ],
            },

            {
                featureType: 'road.arterial',
                elementType: 'labels.text.stroke',
                stylers: [
                    {
                        color: '#2c2c2c',
                    },
                ],
            },

            {
                featureType: 'road.local',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#000000',
                    },
                    {
                        lightness: 16,
                    },
                ],
            },

            {
                featureType: 'road.local',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        color: '#999999',
                    },
                ],
            },

            {
                featureType: 'transit',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#000000',
                    },
                    {
                        lightness: 19,
                    },
                ],
            },

            {
                featureType: 'water',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#000000',
                    },
                    {
                        lightness: 17,
                    },
                ],
            },
        ],
        tcw: [
            {
                featureType: 'all',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        saturation: '1006',
                    },
                    {
                        lightness: 40,
                    },
                    {
                        color: '#5e5e5e',
                    },
                ],
            },
            {
                featureType: 'all',
                elementType: 'labels.text.stroke',
                stylers: [
                    {
                        visibility: 'on',
                    },
                    {
                        color: '#ffffff',
                    },
                    {
                        lightness: 16,
                    },
                ],
            },
            {
                featureType: 'all',
                elementType: 'labels.icon',
                stylers: [
                    {
                        visibility: 'off',
                    },
                ],
            },
            {
                featureType: 'administrative',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        color: '#fefefe',
                    },
                    {
                        lightness: 20,
                    },
                ],
            },
            {
                featureType: 'administrative',
                elementType: 'geometry.stroke',
                stylers: [
                    {
                        color: '#fefefe',
                    },
                    {
                        lightness: 17,
                    },
                    {
                        weight: 1.2,
                    },
                ],
            },
            {
                featureType: 'administrative.neighborhood',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        color: '#5e5e5e',
                    },
                ],
            },
            {
                featureType: 'landscape',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#dedede',
                    },
                    {
                        lightness: 20,
                    },
                ],
            },
            {
                featureType: 'landscape',
                elementType: 'labels.text',
                stylers: [
                    {
                        saturation: '0',
                    },
                    {
                        lightness: '0',
                    },
                ],
            },
            {
                featureType: 'poi',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#f5f5f5',
                    },
                    {
                        lightness: 21,
                    },
                ],
            },
            {
                featureType: 'poi.park',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#dedede',
                    },
                    {
                        lightness: 21,
                    },
                ],
            },
            {
                featureType: 'road.highway',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        color: '#f2f2f2',
                    },
                    {
                        lightness: 17,
                    },
                ],
            },
            {
                featureType: 'road.highway',
                elementType: 'geometry.stroke',
                stylers: [
                    {
                        color: '#f2f2f2',
                    },
                    {
                        lightness: 29,
                    },
                    {
                        weight: 0.2,
                    },
                ],
            },
            {
                featureType: 'road.arterial',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#ffffff',
                    },
                    {
                        lightness: 18,
                    },
                ],
            },
            {
                featureType: 'road.arterial',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        color: '#f2f2f2',
                    },
                ],
            },
            {
                featureType: 'road.arterial',
                elementType: 'geometry.stroke',
                stylers: [
                    {
                        color: '#f2f2f2',
                    },
                ],
            },
            {
                featureType: 'road.local',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#ffffff',
                    },
                    {
                        lightness: 16,
                    },
                ],
            },
            {
                featureType: 'road.local',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        color: '#f2f2f2',
                    },
                ],
            },
            {
                featureType: 'road.local',
                elementType: 'geometry.stroke',
                stylers: [
                    {
                        color: '#f2f2f2',
                    },
                ],
            },
            {
                featureType: 'transit',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#f2f2f2',
                    },
                    {
                        lightness: 19,
                    },
                ],
            },
            {
                featureType: 'water',
                elementType: 'geometry',
                stylers: [
                    {
                        lightness: 17,
                    },
                    {
                        color: '#c0c0c0',
                    },
                ],
            },
        ],
    };

    if ( body.hasClass( 'tbw' ) ) {
        iconStyles = googleMapIcons.tbw;
        mapStyle = googleMapThemes.tbw;
    } else {
        iconStyles = googleMapIcons.tcw;
        mapStyle = googleMapThemes.tcw;
    }

    // --------------------------------------------------
    // EVENTS
    // --------------------------------------------------
    $( window ).on( 'load', function() {
        // Add 'window load' logic here.
    } );

    $( document ).ready( function() {
        if ( $( '.js--event-map' ).length || $( '.js--neighbourhood-map' ).length ) {
            initMap(  );
        }
    } );

    $( window ).on( 'scroll', scrollEventHandler );

    $( window ).on( 'resize', resizeEventHandler );

    window.addEventListener( 'touchstart', touchStartEventHandler );

    // --------------------------------------------------
    // DECLARE FUNCTIONS
    // --------------------------------------------------
    /**
     * Wrapper around *any* logic which should be triggered on window scroll.
     */
    function scrollEventHandler( e ) {
        // Add 'window scroll' logic here.
    }

    /**
     * Wrapper around *any* logic which should be triggered on window resize.
     */
    function resizeEventHandler( e ) {
        // Add 'window resize' logic here.
    }

    /**
     * Wrapper around *any* logic which should be triggered on touch.
     */
    function touchStartEventHandler( e ) {
        var siteBody = $( '.js--body' );
        if ( !siteBody.hasClass( 'touch-device' ) ) {
            siteBody.addClass( 'touch-device' );
        }
    }

    function initMap(  ) {
        if ( Array.isArray( barCoords ) ) {
            let markerScaledSize;
            let markerAnchor;
            let markerLabelFontSize;

            if ( window.innerWidth < 768 ) {
                markerScaledSize = new google.maps.Size( 32, 32 );
                markerAnchor = new google.maps.Point( 16, 16 );
                markerLabelFontSize = 13;
            } else {
                markerScaledSize = new google.maps.Size( 34, 34 );
                markerAnchor = new google.maps.Point( 17, 17 );
                markerLabelFontSize = 15;
            }

            // The map, centered at barCoords
            const map = new google.maps.Map(
                document.querySelector( '.js--neighbourhood-map' ),
                {
                    zoom: 16,
                    scrollwheel: false,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: false,
                    styles: mapStyle,
                }
            );

            // create map bounds object
            const bounds = new google.maps.LatLngBounds(  );

            let markers = [];
            // loop through barCoords and add to map
            for ( let i = 0; i < barCoords.length; i++ ) {
                // get current location
                const location = barCoords[ i ];

                if ( !location.lat || !location.lng ) {
                    // Skip bars with no location
                    continue;
                }

                const itemNumber = i + 1;

                // create map position
                const position = new google.maps.LatLng(
                    location.lat,
                    location.lng
                );

                // add position to bounds
                bounds.extend( position );

                // create marker (  https://developers.google.com/maps/documentation/javascript/reference#MarkerOptions  )
                const marker = new google.maps.Marker( {
                    map: map,
                    position: position,
                    icon: {
                        url: iconStyles.neighbourhoodMapIcon,
                        origin: new google.maps.Point( 0, 0 ),
                        anchor: markerAnchor,
                        scaledSize: markerScaledSize,
                    },
                    label: {
                        color: body.hasClass( 'tbw' ) ? '#000' : '#fff',
                        fontSize: `${markerLabelFontSize}px`,
                        fontWeight: '600',
                        text: `${itemNumber}`,
                    },
                    zIndex: 10 + itemNumber,
                } );

                const infowindow = new SnazzyInfoWindow( {
                    marker: marker,
                    content: `
                        <h1 class='bar-name'>#${itemNumber} - ${
                        location[ 'name' ]
                    }</h1>
                        <p class='bar-address'>${location[ 'address' ]}</p>
                        ${
                            location[ 'url' ]
                                ? `<a class='bar-url' target='_blank' href='${
                                      location[ 'url' ]
                                  }'>Website</a>`
                                : ''
                        }
                    `,

                    placement: 'top',
                    wrapperClass: 'google-map-marker',

                    offset: {
                        top: '-26px',
                        left: '100px',
                    },

                    // style
                    border: false,

                    showCloseButton: true,
                    pointer: false,

                    panOnOpen: true,
                    openOnMarkerClick: true,
                    closeOnMapClick: true,
                    closeWhenOthersOpen: true,
                } );

                markers.push( marker );
            }

            // Set a minimum zoom
            google.maps.event.addListenerOnce( map, 'bounds_changed', function() {
                this.setZoom( Math.min( 16, this.getZoom() ) );
            } );

            // fit map to bounds
            map.fitBounds( bounds );

            google.maps.event.addDomListener( window, 'resize', function() {
                map.fitBounds( bounds );
            } );

            $( '.js--bar-item' ).on( 'click', function() {
                if ( $( '.js--body' ).hasClass( 'touch-device' ) ) {
                    const markerIndex = $( this ).data( 'marker' );
                    const target = $( '.js--neighbourhood-map' );
                    const marker = markers[ markerIndex ];

                    marker.setZIndex( google.maps.Marker.MAX_ZINDEX + 1 );
                    map.setCenter( marker.getPosition(  ) );
                    map.setZoom( 17 );
                    google.maps.event.trigger( marker, 'click' );

                    $( 'html, body' ).animate(
                        {
                            scrollTop: target.offset(  ).top,
                        },
                        1000
                    );
                }
            } );
        } else {
            let markerScaledSize;
            let markerAnchor;
            let mapCenterOffset;

            if ( window.innerWidth < 768 ) {
                markerScaledSize = new google.maps.Size( 50, 55 );
                markerAnchor = new google.maps.Point( 25, 55 );
                mapCenterOffset = -25;
            } else {
                markerScaledSize = new google.maps.Size( 60, 66 );
                markerAnchor = new google.maps.Point( 30, 66 );
                mapCenterOffset = -30;
            }

            // The map, centered at barCoords
            const map = new google.maps.Map(
                document.querySelector( '.js--event-map' ),
                {
                    zoom: 16,
                    center: barCoords,
                    scrollwheel: false,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: false,
                    styles: mapStyle,
                }
            );

            // The marker, positioned at barCoords
            const marker = new google.maps.Marker( {
                position: barCoords,
                map: map,
                icon: {
                    url: iconStyles.eventMapIcon,
                    size: new google.maps.Size( 60, 66 ),
                    origin: new google.maps.Point( 0, 0 ),
                    anchor: markerAnchor,
                    scaledSize: markerScaledSize,
                },
            } );

            map.panBy( 0, mapCenterOffset );

            google.maps.event.addDomListener( window, 'resize', function() {
                map.setCenter( barCoords );
                map.panBy( 0, mapCenterOffset );
            } );
        }
    }
} )( window, document, jQuery );
